import React from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import $ from 'jquery';
import config from '.././config.json';
import '../App.css';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

import { Form, Input, Button, Select, Modal } from 'antd';
import { Map } from 'immutable';
const FormItem = Form.Item;
const Option = Select.Option;

class EmailEditor extends React.Component {

    constructor(props) {
        super(props);

        const html = '<p></p>';
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.state = {
                editorState,
                classes: [],
                selectedClass: '',
                login: true,
                filterSystem: "All"
            };
        }
        this.displayList = [];


    }

    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.refresh(); }); //login
    }

    refresh() {
        this.ajaxCall('GET', '/api/classes/getall',
            {}, (data) => {//success
                this.displayList = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].SystemName == this.state.filterSystem || this.state.filterSystem == "All") {
                        this.displayList.push(
                            <Option key={data[i].Id}>{data[i].Name}</Option>
                        );
                    }

                };
                this.setState({
                    classes: data
                })

            }, () => {//fail
                console.log('failed to get data');
            });
    }

    handleSelectChangeSystem = (value) => {
        this.setState({ filterSystem: value });
        this.refresh()
    }


    render() {
        const { getFieldDecorator } = this.props.form;

        const { editorState } = this.state;
        return (
            <div>
                {this.state.login ?
                    <Form onSubmit={this.handleSubmit}>
                        <h2>Email Class</h2>
                        <hr />
                        <FormItem
                            label="Certification System">
                            {getFieldDecorator('system', {
                                initialValue: this.state.filterSystem
                            })(
                                <Select style={{ width: 300 }}
                                    placeholder="Select the system this class belongs to"
                                    onChange={this.handleSelectChangeSystem}>
                                    <Option value="All">All</Option>
                                    <Option value="TCP">TCP</Option>
                                    <Option value="ESCC">ESCC</Option>
                                    <Option value="External Civil Rights Training">External Civil Rights Training</Option>
                                </Select>

                            )}
                        </FormItem>
                        <FormItem label="Class" >
                            {getFieldDecorator('email', {
                                rules: [{
                                    required: true, message: 'Required!',
                                }],
                            })(
                                <Select
                                    placeholder="Begin typing to search for classes"
                                    onChange={this.handleChange}
                                    style={{ width: 800 }}
                                    showSearch
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                                    {this.displayList}
                                </Select>)}
                        </FormItem>

                        <FormItem label="Subject">
                            {getFieldDecorator('subject', {
                                rules: [{
                                    required: true, message: 'Required!',
                                }],
                            })(
                                <Input placeholder="E-mail subject" id="email" style={{ width: 800 }} />)}
                        </FormItem>
                        <FormItem label="Bcc [Note: Separate multiple email using semicolon(;)]">
                            {getFieldDecorator('bcc', {
                                rules: [{
                                    required: true, message: 'Required!',
                                }]
                            })(
                                <Input placeholder="Bcc" style={{ width: 800 }} />)}
                        </FormItem>
                        <FormItem>
                            <div className="ui card" style={{ width: 700, outline: 1, height: 400, color: '#000', padding: 10 }}>
                                <Editor
                                    editorState={this.state.editorState}
                                    onEditorStateChange={this.onEditorStateChange}
                                    toolbarClassName="home-toolbar"
                                    wrapperClassName="home-wrapper"
                                    editorClassName="home-editor" />
                            </div>
                        </FormItem>
                        <FormItem>
                            <button type="submit" className="btn btn-default" size="large">Submit</button>
                        </FormItem>
                    </Form>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    handleChange = (value) => {
        this.setState({
            selectedClass: value
        });

    }


    onEditorStateChange = (editorState) => {
        console.log(editorState);
        this.setState({
            editorState,
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.content = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));
                this.subject = values.subject;
                this.emailContent = { classId: this.state.selectedClass, subject: this.subject, content: this.content, bcc: values.bcc };
                this.ajaxCall('POST', '/api/classes/email',
                    this.emailContent, (data) => {
                        console.log('system', data);
                        this.success();
                        this.props.form.resetFields();
                        const editorState = EditorState.push(this.state.editorState, ContentState.createFromText(''));
                        this.setState({ editorState });

                    }, () => {
                        console.log('failed to get ClassSystem data');
                    });
            }
        });

    }

    success() {
        const modal = Modal.success({
            title: 'Email successfully Sent',
        });
        setTimeout(() => modal.destroy(), 2000);
    }


}



const WrappedEmail = Form.create()(EmailEditor);
export default WrappedEmail;


// WEBPACK FOOTER //
// ./src/Admin/EmailEditor.js